export default __webpack_public_path__ + "static/media/1229.1cb6cdd4.png";